import * as React from "react";
import { ChessPiece } from "../models/chessPiece";
import { FC } from "react";
import "./PiecesList.scss";
import clsx from "clsx";
import { pieceIcon } from "./pieceIcons";

export type PiecesListProps = {
  pieces: ChessPiece[];
  currentPieceIndex: number;
};

export const PiecesList: FC<PiecesListProps> = ({
  pieces,
  currentPieceIndex,
}) => {
  // Fraction of the track that is "done" — drives the grape progress fill.
  const progress =
    pieces.length > 1
      ? Math.min(currentPieceIndex / (pieces.length - 1), 1)
      : currentPieceIndex > 0
      ? 1
      : 0;

  return (
    <div
      className="pieceTrack"
      style={{ ["--progress" as any]: `${progress}` }}
    >
      {pieces.map((piece, index) => {
        const used = index < currentPieceIndex;
        const active = index === currentPieceIndex;
        return (
          <div
            key={index}
            className={clsx("pieceStep", {
              "pieceStep--used": used,
              "pieceStep--active": active,
            })}
          >
            <div className="pieceStep-marker">
              <img
                className="pieceStep-icon"
                src={pieceIcon(piece, active || used)}
                alt={piece}
                draggable={false}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
